/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField, Typography } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";

const FeedbackComponentEditor = () => {
    
    const { component, update } = useUpdateComponent();
    const { primary_question: question } = component || {};
    
    const onChangeQuestion = (event) => {
        const nextQuestion = event.target.value;
        update("primary_question", nextQuestion);
    };
    
    return (
        <div className='simplicity-editor-frame'>
            <Typography variant='overline' color={"text.secondary"}>
                Primary Question:
            </Typography>
            <TextField
                fullWidth={true}
                placeholder='Add your feedback request here.'
                value={question}
                onChange={onChangeQuestion}
            />
        </div>
    );
};
FeedbackComponentEditor.displayName = "FeedbackComponentEditor";
export { FeedbackComponentEditor };
